import { useTranslation } from 'react-i18next';
import { Grid } from '@mui/material';
import LabelValue from '../../LabelValue';
import type { Provider } from '../../../data/models/provider.model';
import { useBooleanStatus } from '../../../hooks/useBooleanStatus';
import { useActiveStatus } from '../../../hooks/useActiveStatus';
import { useTransportationType } from '../../../hooks/useTransportationType';
import { useLoggedInProviderId } from '../../../hooks/useLoggedInProviderId';
import { FULLSTORY_MASK_CLASSNAME } from '../../../services/analyticsUtils';

interface TransportationInfoProps {
  provider: Provider | null;
  isInternalUser: boolean;
}

export default function TransportationInfo({
  provider,
  isInternalUser,
}: TransportationInfoProps) {
  const { t } = useTranslation('common');
  const canViewProviderId = !useLoggedInProviderId();

  return (
    <>
      <Grid container spacing={2}>
        <Grid item lg={3} md={6} sm={12}>
          <LabelValue
            label={t('provider.type')}
            value={useTransportationType(provider?.transportationTypeID)}
          />
        </Grid>
        {canViewProviderId && (
          <Grid item lg={3} md={6} sm={12}>
            <LabelValue
              label={t('provider.accountNumber')}
              value={provider?.accountNumber}
            />
          </Grid>
        )}
        <Grid item lg={3} md={6} sm={12}>
          <LabelValue
            label={t('provider.hasUnlimitedTrips')}
            value={useBooleanStatus(provider?.hasUnlimitedTrips)}
          />
        </Grid>
        <Grid item lg={3} md={6} sm={12}>
          <LabelValue
            label={t('common.clearToTransport')}
            value={useBooleanStatus(provider?.isClearToTransport)}
          />
        </Grid>
        <Grid item lg={3} md={6} sm={12}>
          <LabelValue
            label={t('common.status')}
            value={useActiveStatus(provider?.transportationProviderState)}
          />
        </Grid>
        <Grid item lg={3} md={6} sm={12}>
          <LabelValue
            label={t('provider.npiNumber')}
            value={provider?.npiNumber}
            className={FULLSTORY_MASK_CLASSNAME}
          />
        </Grid>
        {isInternalUser && (
          <Grid item lg={3} md={6} sm={12}>
            <LabelValue
              label={t('provider.isInternal')}
              value={useBooleanStatus(provider?.isInternal)}
            />
          </Grid>
        )}
      </Grid>
    </>
  );
}
